import { createContext, Dispatch, SetStateAction } from "react";
import { ThemeInt } from "../components/Charts/helpers/types";

export const ThemeContext = createContext<{ theme: ThemeInt; setTheme: Dispatch<SetStateAction<ThemeInt>> }>({
  theme: "dark",
  setTheme(): void {},
});
